module.exports = __webpack_public_path__ + "img/MEDIA030.4db30792.jpg";